export default __webpack_public_path__ + "12ed6b109c8989b62a3948eac4646a64.svg";